enum ComfortClass {
	None = 'none',
	SecondClass = '2nd class'
}

export default ComfortClass;
